import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const DELAY_REASON_URL = `${POSITION_PROPERTY_URL}/delay-reasons`

const errors = createHandbookResponseErrors('причину просрочки заказа', 'причин просрочки заказа')

export const DelayReasonApi = createNewHandbookApi(DELAY_REASON_URL, errors)
